module.exports = __webpack_public_path__ + "img/false.ada98a18.svg";